const form = {
  formId: "tax-personal-05",
  formField: {
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId1: {
      name: "taxId1",
      label: "[05] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    address: {
      name: "address",
      label: "[06] Địa chỉ",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    province: {
      name: "province",
      label: "[06d] Tỉnh/Thành phố",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    district: {
      name: "district",
      label: "[06c] Quận/Huyện/Thị xã/tp thuộc tỉnh",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn",
    },
    ward: {
      name: "ward",
      label: "[06b] Phường/Xã/Thị trấn",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn",
    },
    homeNumber: {
      name: "homeNumber",
      label: "[06a] Số nhà, đường phố/xóm/ấp/thôn",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn",
    },
    phone: {
      name: "phone",
      label: "[07] Điện thoại",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
      invalidMsg: "Số điện thoại không hợp lệ",
    },
    fax: {
      name: "fax",
      label: "[08] Fax",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập fax",
    },
    email: {
      name: "email",
      label: "[09] Email",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[11] Tên đại lý thuế (nếu có)",
      type: "text",
      placeholder: "",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[12] Mã số thuế đại lý",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    agencyContract: {
      name: "agencyContract",
      label: "[13] Hợp đồng đại lý thuế:Số:",
      type: "text",
      placeholder: "",
    },
    agencyContractDate: {
      name: "agencyContractDate",
      label: "Ngày",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày",
    },
    documents: {
      name: "documents",
      label: "[14] Hợp đồng đại lý thuế:Số:",
      type: "text",
      placeholder: "",
    },
    documentsDate: {
      name: "documentsDate",
      label: "Ngày",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày",
    },

    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
